'use strict';

var propTypes = require('./prop-types.js');
var isDefinedAndNotNull = require('./is-defined-and-not-null.js');
var isFunction = require('./is-function.js');
var getSafeDocumentBody = require('./get-safe-document-body.js');
require('@babel/runtime/helpers/defineProperty');
require('prop-types/factoryWithTypeCheckers');
require('./constants.js');
require('./is-defined.js');
require('./is-null.js');
require('./can-use-dom.js');
require('exenv');

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var focusableElements = Object.freeze(['a[href]:not([disabled])', 'button:not([disabled])', 'textarea:not([disabled])', 'input[type="text"]:not([disabled])', 'input[type="search"]:not([disabled])', 'input[type="password"]:not([disabled])', 'input[type="radio"]:not([disabled])', 'input[type="checkbox"]:not([disabled])', 'select:not([disabled])']);
/**
 * Get all focusable elements inside element passed.
 *
 * @function
 * @param {HTMLElement} [element=document.body] - Container of focusable elements.
 * @returns {Array} Returns an array of all focusable elements.
 * @example
 * getFocusableElements();
 */

var getFocusableElements = function getFocusableElements() {
  var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getSafeDocumentBody();
  var elementToProcess = isDefinedAndNotNull(element) ? element : getSafeDocumentBody();

  if (isFunction(elementToProcess.querySelectorAll)) {
    return elementToProcess.querySelectorAll(focusableElements.join(','));
  }

  return [];
};

getFocusableElements.HELPER_ID = 'Gearz.JsUtils.getFocusableElements';
getFocusableElements.returnType = propTypes.arrayOfWithDescription(propTypes.instanceOf(HTMLElement), 'Returns an array of all focusable elements.');
getFocusableElements.parameterTypes = {
  element: propTypes.instanceOfWithDescription(HTMLElement, 'Container of focusable elements.')
};
getFocusableElements.defaultParameters = {
  element: getSafeDocumentBody()
};

module.exports = getFocusableElements;
